// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"29af46ca","453":"49ec4f51"}[chunkId] + ".chunk.js";
};